<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      v-if="hasRole('>=MODERATOR')"
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="SitesAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="site in results" :key="site.id" :xl="6">
          <RecordSite :site="site" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordSite from './components/RecordSite'
import Table from '@mixins/Table'

export default {
  mixins: [Table],
  components: { RecordSite },
  data() {
    // const { authUser, hasRole } = this.$store.getters

    return {
      paginationOptions: {
        name: 'adminSite',
        service: 'site',
        // customQuery: hasRole('>=ADMIN')
        //   ? {}
        //   : { userId: authUser.id },
        searchIn: [
          'name',
          'url',
        ],
        filters: [
          {
            label: 'Name',
            append: ['name', '$ilike'],
          },
          {
            label: 'Created since',
            type: 'date',
            append: ['createdAt', '$gte'],
          },
          {
            label: 'Created before',
            type: 'date',
            append: ['createdAt', '$lte'],
          },
        ],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Sites",
    "button": "Add a site",
    "all": "All"
  }
}
</i18n>
